import {Button} from 'platform/components';
import {Box, HStack, VStack} from 'platform/foundation';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import i18n from '@dms/i18n';
import {DmsDataGrid, refreshDmsDatagrid} from '@dms/shared';

import {Nullish, TestIdProps, suffixTestId} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface AvailabilityTabProps extends TestIdProps {
  manufacturerId: string | Nullish;
  manufacturerNumber: string | Nullish;
}

export function RequestTabMaterialAvailabilityTab(props: AvailabilityTabProps) {
  const queryModifier = useCallback(
    (filter: QueryFilterObject) =>
      mergeAll([
        filter,
        {
          articleId: undefined,
          catalogNumber: undefined,
          manufacturerNumber: props.manufacturerNumber,
          manufacturer: props.manufacturerId,
        },
      ]),
    [props.manufacturerNumber, props.manufacturerId]
  );

  return (
    <VStack spacing={0}>
      <Box height={50}>
        <DmsDataGrid
          gridCode="warehouse-availability"
          queryModifier={queryModifier}
          data-testid={suffixTestId('availability', props)}
        />
      </Box>
      <HStack justify="flex-end">
        <Button
          variant="link"
          title={i18n.t('general.actions.refresh')}
          leftIcon="navigation/refresh"
          onClick={() => refreshDmsDatagrid('warehouse-availability')}
          data-testid={suffixTestId('refresh', props)}
        />
      </HStack>
    </VStack>
  );
}
